<template>
  <div>
    <div id="printPage" ref="print">
      <div class="left">
        <span style="left: 55px; top: 155px">RAKUMART</span><!--寄件人-->
        <span style="left: 480px; top: 500px;height: 40px;">RAKUMART</span><!--公司。-->
        <span style="left: 30px; top: 215px" v-html="$parent.textToHtml(companyAddress)"></span>
        <!-- <span style="left: 0px; top: 266px"
          >4th,Unit A1-1,Mall Pioneer Park,<br />No.117 Qiushi Road,Yiwu
          City,Zhejiang <br />(陈舒怀)</span
        > -->
        <!--公司地址。-->
        <span style="left: 258px; top: 255px">322000</span><!--公司。-->

        <span style="left: 95px; top: 255px">{{ mobile }}</span><!--电话。-->
        <span style="left:223px; top: 175px">china</span><!--国家。-->
        <span style="left: 0px; top: 480px; word-break: break-all; width: 250px"></span>
        <!--备注。-->
        <span style="left: 480px; top: 485px">
          {{
            specifiedFormatDate({ format: "yyyy" })
          }}
          {{
            specifiedFormatDate({ format: "mm" })
          }}
          {{
            specifiedFormatDate({ format: "dd" })
          }}
        </span>
        <span style="left: 0px; top: 310px;width: 800px;">インボイスを参照ください</span>
        <span style="left: 0px; top: 330px;width: 800px;" v-if="receiver.bank_no">リアルタイム口座 :{{ receiver.bank_no
        }}</span>
        <span style="left: 400px; top: 330px;width: 800px;" v-if="receiver.standard_no">輸出入者標準コード: {{
          receiver.standard_no
        }}</span>
      </div>
      <div class="right">
        <span style="left: 500px; top: 00px">{{ $route.query.sn || "" }} {{ $route.query.p_username }}</span>
        <span style="left: 325px; top: 135px">{{ $route.query.weight || "" }}</span><!--寄件人-->
        <span style="left: 400px; top: 153px">{{ receiver.contacts }}様</span><!--名称-->
        <span style="left: 570px; top: 175px">日本</span><!--名称-->
        <span style="left: 400px; top: 208px;width: 250px; word-break: break-all;"
          v-html="$parent.textToHtml(receiver.address)"></span><!--地址-->
        <span style="left: 605px; top: 255px">{{ receiver.zip_code }}</span><!--地址-->
        <span style="left: 440px; top: 255px">{{ receiver.mobile }}</span>

        <!--地址-->
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" @click="save"> 复制页面代码数据</el-button>
      <el-button type="primary" @click="print"> 打印</el-button>
    </div>
  </div>
</template>
<script>
import { specifiedFormatDate } from "@/utlis/date";
import { mapState } from "vuex";
export default {
  data() {
    return { specifiedFormatDate };
  },
  created() { },
  mounted() {
    // this.print()
  },
  computed: {
    ...mapState({
      receiver: (state) => state.porderDetail.receiver, //进口商信息
    }),
    companyAddress() {
      switch (this.$route.query.department) {
        case "一部":
          return `3th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        case "二部":
          return `4th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        case "三部":
          return `5th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        case "四部":
          return `3th Floor, Unit2,NO.37Jingsan
Road,Beiyuan Street,Yiwu City,Zhejiang Province
(${this.$route.query.y_name || ""})`;
          break;
        default:
          break;
      }
      return;
    },
    mobile() {
      switch (this.$route.query.department) {
        case "一部":
          return `15067546083`;
          break;
        case "二部":
          return `18606888793`;
          break;
        case "三部":
          return `18268222365`;
          break;
        case "四部":
          return `15067546083`;
          break;
        default:
          break;
      }
      return;
    },
  },
  methods: {
    print() {
      this.$nextTick(() => {
        this.$print(this.$refs.print);
      });
      // this.$print(this.$refs.print)
    },
    save() {
      let copyUrl = this.$refs.print.innerHTML;
      let oInput = document.createElement("input"); //创建一个隐藏input（重要！）
      oInput.value = copyUrl; //赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = "oInput";
      oInput.style.display = "none";
      alert("复制成功");
      // console.log(copyUrl);
    },
  },
};
</script>
<style lang="scss" scoped>
.btn {
  margin: 20px auto;
  text-align: center;
}

.left {
  float: left;
  width: 435px;
  height: 583px;

  left: 0;
}

.right {
  float: right;
  width: 435px;
  height: 583px;

  left: 0;
  /*right: 0;*/
}

#printPage {
  width: 874px;
  height: 585px;
  position: relative;
  color: #000;
  font-family: "Helvetica Neue";
}

span {
  font-size: 12px;
  display: block;
  position: absolute;


}
</style>
